<template>
  <div class="twcs-fixed twcs-inset-0 twcs-overflow-hidden twcs-z-[1001]">
    <div class="twcs-absolute twcs-inset-0 twcs-overflow-hidden">
      <Transition
        enter-active-class="twcs-ease-in-out twcs-duration-300"
        enter-from-class="twcs-opacity-0"
        enter-to-class="twcs-opacity-100"
        leave-active-class="twcs-ease-in-out twcs-duration-500"
        leave-from-class="twcs-opacity-100"
        leave-to-class="twcs-opacity-0"
      >
        <!--
          Background overlay, show/hide based on slide-over state.

          Entering: "ease-in-out duration-500"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in-out duration-500"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div v-if="modalShow" class="twcs-absolute twcs-inset-0 twcs-bg-gray-500 twcs-bg-opacity-75 twcs-transition-opacity" aria-hidden="true"></div>
      </Transition>
      <section class="twcs-absolute twcs-inset-y-0 twcs-right-0 twcs-pl-10 twcs-max-w-full twcs-flex" aria-labelledby="slide-over-heading" @keydown="onKeydownEvent">
        <Transition
          enter-active-class="twcs-transform twcs-transition twcs-ease-in-out twcs-duration-300 sm:twcs-duration-500"
          enter-from-class="twcs-translate-x-full"
          enter-to-class="twcs-translate-x-0"
          leave-active-class="twcs-transform twcs-transition twcs-ease-in-out twcs-duration-500 sm:twcs-duration-700"
          leave-from-class="twcs-translate-x-0"
          leave-to-class="twcs-translate-x-full"
        >
          <!--
            Slide-over panel, show/hide based on slide-over state.

            Entering: "transform transition ease-in-out duration-500 sm:duration-700"
              From: "translate-x-full"
              To: "translate-x-0"
            Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
              From: "translate-x-0"
              To: "translate-x-full"
          -->
          <div v-if="modalShow" class="twcs-w-screen twcs-max-w-md">
            <div class="twcs-h-full twcs-flex twcs-flex-col sm:twcs-pt-6 sm:twcs-pb-4 twcs-bg-white twcs-shadow-xl">
              <div class="twcs-relative">
                <div class="twcs-px-4 twcs-py-1 sm:twcs-px-6 twcs-sticky">
                  <div class="twcs-col-span-1 twcs-grid twcs-grid-cols-6 twcs-gap-2">
                    <div class="twcs-flex twcs-items-center twcs-justify-start">
                      <button
                        v-show="panels[currentPanelIndex].parentPanelId"
                        @click.prevent="onBackClick()"
                        class="twcs-mr-2 focus-visible:twcs-outline-none focus-visible:twcs-ring-2 focus-visible:twcs-ring-offset-2 focus-visible:twcs-ring-kctcs-gold-200"
                        ref="backButtonRef"
                      >
                        <span class="twcs-sr-only">Back to filters</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="twcs-h-6 twcs-w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                      </button>
                    </div>
                    <div class="twcs-col-span-4 twcs-justify-center">
                      <h2 id="slide-over-heading" class="twcs-m-0 twcs-text-center twcs-text-lg twcs-font-medium twcs-text-gray-900">
                        {{ panels[currentPanelIndex].text }}
                      </h2>
                    </div>
                    <div class="twcs-col-span-1 twcs-flex twcs-items-center twcs-justify-end">
                      <button
                        @click="onClose()"
                        class="twcs-bg-white twcs-rounded-md twcs-text-gray-400 hover:twcs-text-gray-500 focus:twcs-outline-none focus-visible:twcs-ring-2 focus-visible:twcs-ring-offset-2 focus-visible:twcs-ring-kctcs-gold-200"
                        ref="closeButtonRef"
                      >
                        <span class="twcs-sr-only">Close panel</span>
                        <!-- Heroicon name: outline/x -->
                        <svg class="twcs-h-6 twcs-w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sm:twcs-mt-6 twcs-relative twcs-flex-1 twcs-overflow-y-auto">
                <!-- panel content -->
                <ModalFilterSelect
                  v-if="!isSelectByGroupPanel"
                  :options="currentOptions"
                  :selected="currentSelected"
                  :hasFocus="tabIndex === 0"
                  :filtersSelected="filterSearchStore.filtersSelected"
                  @option-select="choose"
                  @panel-back="onBack"
                />
                <ModalFilterSelectByGroup
                  v-else
                  :options="currentOptions"
                  :selected="currentSelected"
                  :hasFocus="tabIndex === 0"
                  @option-select="chooseByGroup"
                  @panel-back="onBack"
                />
              </div>
              <div class="twcs-flex twcs-justify-center sm:twcs-mt-2 sm:twcs-p-4">
                <button
                  ref="removeFiltersButtonRef"
                  @click.prevent="filterSearchStore.removeAllFilters()"
                  class="twcs-w-full twcs-flex twcs-justify-center twcs-py-2 twcs-px-4 twcs-border-2 twcs-border-transparent twcs-outline-none focus:twcs-outline-none sm:twcs-rounded-md sm:twcs-shadow-sm twcs-text-base twcs-font-medium twcs-text-white twcs-bg-kctcs-navy-600 hover:twcs-bg-kctcs-navy-700 focus-visible:twcs-border-kctcs-gold-200"
                >
                  Remove All Filters
                </button>
              </div>
            </div>
          </div>
        </Transition>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { usePanelStateStore } from '@/stores/panel-state.js';
import { useFilterSearchStore } from '@/stores/filter-search.js';
import ModalFilterSelect from '@/components/ModalFilterSelect.vue';
import ModalFilterSelectByGroup from '@/components/ModalFilterSelectByGroup.vue';

defineProps({
	modalOpen: {
		type: Boolean,
		required: true,
	},
	modalShow: {
		type: Boolean,
		required: true,
	},
});

let emit = defineEmits(['modalCloseOnClick']);

let filterSearchStore = useFilterSearchStore();
const panelState = usePanelStateStore();

const { panels, currentPanelIndex, tabIndex } = storeToRefs(panelState);
// the increment action can just be destructured
const { updateCurrentPanel } = panelState;

let buttonRef = document.activeElement; // ref to the button that opens modal

let isSelectByGroupPanel = computed(() => {
	return panels.value[currentPanelIndex.value].hasOwnProperty('currentCategory') && panels.value[currentPanelIndex.value].hasOwnProperty('currentCategoryIndex');
});

let closeButtonRef = ref(null);
let backButtonRef = ref(null);
let removeFiltersButtonRef = ref(null);

let focusables = [
	'listbox',
	{
		ref: removeFiltersButtonRef,
	},
	{
		ref: backButtonRef,
		showSometimes: true,
	},
	{
		ref: closeButtonRef,
	},
];

let focusablesComputed = computed(() => {
	return panels.value[currentPanelIndex.value].parentPanelId !== null ? focusables : focusables.filter((element) => element === 'listbox' || !element.hasOwnProperty('showSometimes'));
});

let currentOptions = computed(() => {
	return filterSearchStore.options[panels.value[currentPanelIndex.value].id];
});

let currentSelected = computed(() => {
	return filterSearchStore.selected[panels.value[currentPanelIndex.value].id];
});

onMounted(() => {
	// setTimeout(() => {
		tabIndex.value = 0;
	// }, 250);
});

function onBack() {
    tabIndex.value = 0;
}

function onBackClick() {
    updateCurrentPanel(panels.value[currentPanelIndex.value].parentPanelId);
    nextTick(() => {
        tabIndex.value = 0;
    });
}

function onClose() {
	buttonRef.focus();
	emit('modalCloseOnClick', false);
}

function choose(index) {
	if(!panels.value[currentPanelIndex.value].multiselect) { // case: not multiselect
		// if one is selected all others must be false
		filterSearchStore.selected[panels.value[currentPanelIndex.value].id].forEach((value, idx) => {
			if(value) {
		filterSearchStore.patchFilterSelection({
					source: panels.value[currentPanelIndex.value].id,
					text: panels.value[currentPanelIndex.value].text,
					index: idx,
					value: false,
				});
			}
		});
	filterSearchStore.patchFilterSelection({ source: panels.value[currentPanelIndex.value].id, text: panels.value[currentPanelIndex.value].text, index, value: true });
	} else { // case: is multiselect
		if(filterSearchStore.selected[panels.value[currentPanelIndex.value].id][index] && !(currentOptions.value[index].hasOwnProperty('type') && currentOptions.value[index].type === '*')) {
			// if the selected option is already selected and not the catch-all, deselect it
		filterSearchStore.patchFilterSelection({ source: panels.value[currentPanelIndex.value].id, text: panels.value[currentPanelIndex.value].text, index, value: false });
			if(!filterSearchStore.selected[panels.value[currentPanelIndex.value].id].includes(true)) {
				// if after deselection all options are unselected, find catch-all and select it if it exists
				currentOptions.value.forEach((option, idx) => {
					if(option.hasOwnProperty('type') && option.type === '*') {
				filterSearchStore.patchFilterSelection({
							source: panels.value[currentPanelIndex.value].id,
							text: panels.value[currentPanelIndex.value].text,
							index: idx,
							value: true,
						});
					}
				});
			}
		} else if(currentOptions.value[index].hasOwnProperty('type') && currentOptions.value[index].type === '*') {
			// if option is catch-all
			if(!filterSearchStore.selected[panels.value[currentPanelIndex.value].id][index]) {
				// if catch-all is not already selected, deselect all options and select catch-all
				filterSearchStore.selected[panels.value[currentPanelIndex.value].id].forEach((value, idx, values) => {
					if(values[idx]) {
				filterSearchStore.patchFilterSelection({
							source: panels.value[currentPanelIndex.value].id,
							text: panels.value[currentPanelIndex.value].text,
							index: idx,
							value: false,
						});
					}
				});
		filterSearchStore.patchFilterSelection({
					source: panels.value[currentPanelIndex.value].id,
					text: panels.value[currentPanelIndex.value].text,
					index,
					value: true,
				});
			}
		} else {
			// else
		filterSearchStore.patchFilterSelection({ source: panels.value[currentPanelIndex.value].id, text: panels.value[currentPanelIndex.value].text, index, value: true });
			currentOptions.value.forEach((option, idx) => {
				if(option.hasOwnProperty('type') && option.type === '*' && filterSearchStore.selected[panels.value[currentPanelIndex.value].id][idx]) {
			filterSearchStore.patchFilterSelection({
						source: panels.value[currentPanelIndex.value].id,
						text: panels.value[currentPanelIndex.value].text,
						index: idx,
						value: false,
					});
				}
			});
		}
	}
	filterSearchStore.commitFilter(panels.value[currentPanelIndex.value].id);
}

function chooseByGroup({ index, category }) {
	if(!panels.value[currentPanelIndex.value].multiselect) { // case: not multiselect
		// if one is selected all others must be false
		Object.keys(filterSearchStore.selected[panels.value[currentPanelIndex.value].id]).forEach((key) => {
			filterSearchStore.selected[panels.value[currentPanelIndex.value].id][key].forEach((value, idx) => {
				if(value) {
			filterSearchStore.patchFilterSelection({
						source: panels.value[currentPanelIndex.value].id,
						text: panels.value[currentPanelIndex.value].text,
						key,
						index: idx,
						value: false,
					});
				}
			});
		});
	filterSearchStore.patchFilterSelection({
			source: panels.value[currentPanelIndex.value].id,
			text: panels.value[currentPanelIndex.value].text,
			index,
			key: category,
			value: true,
		});
	} else { // case: is multiselect
		if(filterSearchStore.selected[panels.value[currentPanelIndex.value].id][category][index] && !(currentOptions.value[category][index].hasOwnProperty('type') && currentOptions.value[category][index].type === '*')) {
			// if the selected option is already selected and not the catch-all, deselect it
		filterSearchStore.patchFilterSelection({
				source: panels.value[currentPanelIndex.value].id,
				text: panels.value[currentPanelIndex.value].text,
				key: category,
				index,
				value: false,
			});
			if(!Object.keys(filterSearchStore.selected[panels.value[currentPanelIndex.value].id]).some((key) => filterSearchStore.selected[panels.value[currentPanelIndex.value].id][key].includes(true))) {
				// if after deselection all options are unselected, find catch-all and select it if it exists
		filterSearchStore.patchFilterSelection({
					source: panels.value[currentPanelIndex.value].id,
					text: panels.value[currentPanelIndex.value].text,
					key: '0',
					index: 0,
					value: true,
				});
			}
		} else if(currentOptions.value[category][index].hasOwnProperty('type') && currentOptions.value[category][index].type === '*') {
			// if option is catch-all
			if(!filterSearchStore.selected[panels.value[currentPanelIndex.value].id][category][index]) {
				// if catch-all is not already selected, deselect all options and select catch-all
				Object.keys(filterSearchStore.selected[panels.value[currentPanelIndex.value].id]).forEach((key) => {
					filterSearchStore.selected[panels.value[currentPanelIndex.value].id][key].forEach((value, idx) => {
						if(value) {
					filterSearchStore.patchFilterSelection({
								source: panels.value[currentPanelIndex.value].id,
								text: panels.value[currentPanelIndex.value].text,
								key,
								index: idx,
								value: false,
							});
						}
					});
				});
		filterSearchStore.patchFilterSelection({
					source: panels.value[currentPanelIndex.value].id,
					text: panels.value[currentPanelIndex.value].text,
					key: category,
					index,
					value: true,
				});
			}
		} else {
			// else
		filterSearchStore.patchFilterSelection({
				source: panels.value[currentPanelIndex.value].id,
				text: panels.value[currentPanelIndex.value].text,
				key: category,
				index,
				value: true,
			});
			// deselect the catch-all
		filterSearchStore.patchFilterSelection({
				source: panels.value[currentPanelIndex.value].id,
				text: panels.value[currentPanelIndex.value].text,
				key: '0',
				index: 0,
				value: false,
			});
		}
	}
	filterSearchStore.commitFilter(panels.value[currentPanelIndex.value].id);
}

function onKeydownEvent(event) {
	if(event.key === 'ArrowDown' || event.key === 'ArrowUp') {
		event.preventDefault();
	}

	if(event.key === 'Escape') {
		onClose();
		event.preventDefault();
	}

	if(event.key !== 'Tab') {
		return;
	}
	if(event.shiftKey) {
		// shift+tab
		tabIndex.value = tabIndex.value === 0 ? focusablesComputed.value.length - 1 : tabIndex.value - 1;
		if(tabIndex.value !== 0) {
			focusablesComputed.value[tabIndex.value].ref.value.focus();
		}
	} else {
		// just tab
		tabIndex.value = tabIndex.value === focusablesComputed.value.length - 1 ? 0 : tabIndex.value + 1;
		if(tabIndex.value !== 0) {
			focusablesComputed.value[tabIndex.value].ref.value.focus();
		}
	}
	event.preventDefault();
}
</script>
